export const Resources = {
  COOKIE_CONSENT_BUTTON_ACCEPT: 'I Accept',
  COOKIE_CONSENT_BUTTON_DECLINE: 'I Decline',
  COOKIE_CONSENT_PRIVACY_POLICY_LINK_TEXT: 'here',
  COOKIE_CONSENT_PRIVACY_POLICY_LINK: '/privacy-policy',
  COOKIE_CONSENT_MESSAGE_1:
    'We use cookies to give you a better online experience. View our Privacy Policy ',
  COOKIE_CONSENT_MESSAGE_2:
    "If you decline, we won't track your information when you visit our site. But in order" +
    "to comply with your preferences, we'll have to use just one tiny cookie so that you're not asked to make this choice again.",
  AUTH_SIDE_IMAGE:
    '//images.ctfassets.net/37v1e0z3jkn5/4QwQGNFXlwURbODTZ1DaOG/beba7f29dbf3a2272c4fe450f743853c/side-image.png',
  REGISTRATION_WELCOME_TITLE: 'Welcome to USREM!',
  REGISTRATION_WELCOME_SUBTITLE: "We're excited to have you among our investors.",
  REGISTRATION_WELCOME_OFFERINGS:
    'Our marketplace is operating under strict regulation and we are required to learn more about you before we can let you trade as an "accredited investor".',
  REGISTRATION_WELCOME_NO_OFFERINGS:
    'Our marketplace is operating under strict regulation and we are required to learn more about you before we can let you trade as an "accredited investor".',
  REGISTRATION_PERSONAL_TITLE: 'Let’s start with the basics!',
  REGISTRATION_ADDRESS_TITLE: 'Get approved to see offerings now!',
  REGISTRATION_ACCREDITED_TITLE: 'Are you an accredited investor?',
  REGISTRATION_NOT_ACCREDITED_TITLE: 'Sorry!',
  REGISTRATION_NOT_ACCREDITED_SUBTITLE:
    'Unfortunately, our platform is currently limited to accredited investors only.',
  REGISTRATION_NOT_SOPHISTICATED_TITLE:
    'Thanks for your information. We will get back to you after reviewing your details.',
  REGISTRATION_NOT_SOPHISTICATED_SUBTITLE: 'We will get back to you after reviewing your details.',
  REGISTRATION_NOT_ACCREDITED_BUTTON: 'Done',
  REGISTRATION_INVESTMENT_EXPERIENCE_TITLE: 'What investments do you currently hold?',
  REGISTRATION_INVESTMENT_OBJECTIVE_TITLE: 'What are your investment objectives?',
  REGISTRATION_INVESTMENT_VALUE_TITLE: 'What is the approximate value of your other investments?',
  REGISTRATION_LIQUIDITY_TITLE: 'When would you like liquidity for your real estate investments?',
  REGISTRATION_VERIFY_EMAIL_TITLE: "You're almost done...",
  REGISTRATION_PROFESSION_TITLE: 'What industry do you work in?',
  REGISTRATION_PROFESSION_SUBTITLE: 'If retired, answer for your last occupation.',
  REGISTRATION_DONE_TITLE: 'Congratulations, you’re awesome!',
  REGISTRATION_DONE_SUBTITLE: 'We are done with asking questions, let us get started!',
  REGISTRATION_DONE_BUTTON: 'View offerings',
  REGISTRATION_MARKETPLACE_BUTTON: 'Browse Marketplace',
  REGISTRATION_NEW_PASSWORD: 'New password',
  REGISTRATION_SIGN_IN_TITLE: 'Log In',
  REGISTRATION_SIGN_IN_SUBTITLE:
    'Your account will give you access to our investment opportunities.',
  REGISTRATION_SIGN_UP_TITLE: 'Register your USREM account',
  REGISTRATION_SIGN_UP_SUBTITLE:
    'Your account will give you access to our investment opportunities.',
  REGISTRATION_SIGN_UP_EMAIL_BUTTON: 'Enter Email',
  REGISTRATION_ACTIVATE_TITLE: 'Activate your account',
  REGISTRATION_CONTINUE: 'Continue',
  REGISTRATION_ACTIVATE_USREM_TITLE: 'Activate your USREM Account',
  REGISTRATION_ENTER_PASSWORD_TITLE: 'Enter your password',
  REGISTRATION_ACTIVATE_SUBTITLE:
    'Your account will let you sell your holdings on the marketplace.',
  REGISTRATION_ACTIVATE_BUTTON: 'Activate account',
  ALERT_COMPLETE_REGISTRATION:
    'You have to complete your registration in order to view all offerings.',
  ALERT_COMPLETE_REGISTRATION_ACTION: 'Complete registration',
  ALERT_NOT_ACCREDITED:
    'Unfortunately, our platform is currently limited to accredited investors only.',
  ALERT_NOT_ACCREDITED_ACTION: 'Update my details',
  ALERT_PENDING_SPONSOR:
    'Once USREM has the information on your holdings, you will see them here and be able to sell them on the marketplace.',
  ALERT_EMAIL_WAS_RESENT:
    'We resent an email to verify your account to {email}. No email in your inbox or spam folder?',
  ALERT_EMAIL_LETS_RESEND: 'Let’s resend it.',
  ALERT_EMAIL_NOT_VERIFIED:
    'To use USREM’s platform, click on the verification button in the email sent to you.',
  ALERT_EMAIL_NOT_VERIFIED_ACTION: 'Resend Email',
  OFFERING_METRICS_TABLE_COMMENT:
    '* All metrics presented herein are either provided directly by the sponsor or calculated based on underlying information provided by the sponsor. Past performance is no guarantee of future results.',
  REGISTRATION_CONFIRM_SIGNUP_1: 'We just sent you a one-time code to verify your email address.',
  REGISTRATION_CONFIRM_SIGNUP_2:
    'Please copy the code from the email and paste it here to confirm it’s you.',
  LEGAL_ORDER_BROKER_DEALER:
    'If an entity, I hereby confirm that I am not a broker-dealer; if a person, I hereby confirm that I am not acting as a representative of a broker-dealer.',
  RISK_FACTORS_LEGAL_COMMENT:
    '##### * These Risk Factors are not comprehensive or exclusive. Potential investors should read all Risk Factors disclosed by the Sponsor in the relevant offering memorandum for this investment.'
} as Record<string, string>;
